// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Category Studio (A3): tabbed form + live preview. Design tokens with fallbacks. */

.CategoryStudioForm-layout-CjR4e {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
  gap: 24px;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: start;
}

@media (max-width: 992px) {
  .CategoryStudioForm-layout-CjR4e {
    grid-template-columns: 1fr;
  }
}

.CategoryStudioForm-tabs-vi1Nz {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 4px;
  border-bottom: 1px solid #e4e4e4;
  border-bottom: 1px solid var(--border-color, #e4e4e4);
  margin-bottom: 20px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.CategoryStudioForm-tab-Kvj_V {
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 600;
  color: #606060;
  color: var(--content-text-secondary, #606060);
  cursor: pointer;
}

.CategoryStudioForm-tab-Kvj_V:hover {
  color: #d32f2f;
  color: var(--primary-bg, #d32f2f);
}

.CategoryStudioForm-tabActive-r3zSU {
  color: #d32f2f;
  color: var(--primary-bg, #d32f2f);
  border-bottom-color: #d32f2f;
  border-bottom-color: var(--primary-bg, #d32f2f);
}

.CategoryStudioForm-panel-qLWyW {
  display: none;
}

.CategoryStudioForm-panelActive-IwyiU {
  display: block;
}

.CategoryStudioForm-grid2-WSqPn {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

@media (max-width: 640px) {
  .CategoryStudioForm-grid2-WSqPn {
    grid-template-columns: 1fr;
  }
}

.CategoryStudioForm-fieldFull-W1IWX {
  grid-column: 1 / -1;
}

.CategoryStudioForm-counter-mOrFl {
  font-size: 12px;
  color: #909090;
  color: var(--content-text-secondary, #909090);
  text-align: right;
  margin-top: 2px;
}

.CategoryStudioForm-slugRow-DKbzb {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 8px;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
}

.CategoryStudioForm-slugRow-DKbzb > :first-child {
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
}

.CategoryStudioForm-genBtn-xeTRD {
  white-space: nowrap;
}

/* ---- Live preview ---- */

.CategoryStudioForm-preview-mXh6c {
  position: sticky;
  top: 16px;
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  padding: 16px;
  background: #f9f9f9;
  background: var(--common-light-bg, #f9f9f9);
}

.CategoryStudioForm-previewTitle-NpEJ1 {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #909090;
  color: var(--content-text-secondary, #909090);
  margin-bottom: 12px;
}

.CategoryStudioForm-cardMock-oot_0 {
  background: #fff;
  background: var(--white-color, #fff);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  overflow: hidden;
  margin-bottom: 20px;
}

.CategoryStudioForm-cardBanner-awY7i {
  height: 90px;
  background: linear-gradient(135deg, #d32f2f 0%, #0e9488 100%);
  background-size: cover;
  background-position: center;
}

.CategoryStudioForm-cardBody-T4Z3u {
  padding: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 10px;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.CategoryStudioForm-cardIcon-cDcQE {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  -o-object-fit: cover;
     object-fit: cover;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.CategoryStudioForm-cardIconPlaceholder-ishjZ {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  color: #fff;
  font-weight: 700;
  background: #d32f2f;
  background: var(--primary-bg, #d32f2f);
}

.CategoryStudioForm-cardName-S2UAl {
  font-weight: 700;
  color: #181817;
  color: var(--content-text, #181817);
}

.CategoryStudioForm-cardSub-vBlfC {
  font-size: 12px;
  color: #909090;
  color: var(--content-text-secondary, #909090);
  text-transform: capitalize;
}

.CategoryStudioForm-cardPopular-qxNSS {
  font-size: 10px;
  font-weight: 700;
  color: #fff;
  background: #0e9488;
  border-radius: 999px;
  padding: 2px 7px;
  margin-left: auto;
}

/* SEO snippet (Google-result style) */

.CategoryStudioForm-seoSnippet-vcP_M {
  background: #fff;
  background: var(--white-color, #fff);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  padding: 12px;
}

.CategoryStudioForm-seoUrl-LeEYQ {
  font-size: 12px;
  color: #0e9488;
  word-break: break-all;
}

.CategoryStudioForm-seoTitle-O5U8I {
  color: #1a0dab;
  font-size: 16px;
  margin: 2px 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.CategoryStudioForm-seoDesc-LyiVF {
  font-size: 12px;
  color: #606060;
  color: var(--content-text-secondary, #606060);
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/SiteAdmin/AddCategoryForm/CategoryStudioForm.css"],"names":[],"mappings":"AAAA,oFAAoF;;AAEpF;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,wBAAkB;MAAlB,qBAAkB;UAAlB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,gCAAqD;EAArD,qDAAqD;EACrD,mBAAmB;EACnB,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAA6C;EAA7C,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,cAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,cAAiC;EAAjC,iCAAiC;EACjC,4BAA+C;EAA/C,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,QAAQ;EACR,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;AACvB;;AAEA;EACE,mBAAO;MAAP,aAAO;UAAP,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA,2BAA2B;;AAC3B;EACE,gBAAgB;EAChB,SAAS;EACT,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,aAAa;EACb,mBAA2C;EAA3C,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAA6C;EAA7C,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,gBAAoC;EAApC,oCAAoC;EACpC,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,6DAA6D;EAC7D,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,oBAAiB;KAAjB,iBAAiB;EACjB,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,oBAAc;MAAd,cAAc;EACd,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,cAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sCAAsC;;AACtC;EACE,gBAAoC;EAApC,oCAAoC;EACpC,yBAA8C;EAA9C,8CAA8C;EAC9C,kBAAmC;EAAnC,mCAAmC;EACnC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,gBAAgB;AAClB","sourcesContent":["/* Category Studio (A3): tabbed form + live preview. Design tokens with fallbacks. */\n\n.layout {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) 340px;\n  gap: 24px;\n  align-items: start;\n}\n\n@media (max-width: 992px) {\n  .layout {\n    grid-template-columns: 1fr;\n  }\n}\n\n.tabs {\n  display: flex;\n  gap: 4px;\n  border-bottom: 1px solid var(--border-color, #e4e4e4);\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.tab {\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  padding: 10px 16px;\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--content-text-secondary, #606060);\n  cursor: pointer;\n}\n\n.tab:hover {\n  color: var(--primary-bg, #d32f2f);\n}\n\n.tabActive {\n  color: var(--primary-bg, #d32f2f);\n  border-bottom-color: var(--primary-bg, #d32f2f);\n}\n\n.panel {\n  display: none;\n}\n\n.panelActive {\n  display: block;\n}\n\n.grid2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n@media (max-width: 640px) {\n  .grid2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n.fieldFull {\n  grid-column: 1 / -1;\n}\n\n.counter {\n  font-size: 12px;\n  color: var(--content-text-secondary, #909090);\n  text-align: right;\n  margin-top: 2px;\n}\n\n.slugRow {\n  display: flex;\n  gap: 8px;\n  align-items: flex-end;\n}\n\n.slugRow > :first-child {\n  flex: 1;\n}\n\n.genBtn {\n  white-space: nowrap;\n}\n\n/* ---- Live preview ---- */\n.preview {\n  position: sticky;\n  top: 16px;\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  padding: 16px;\n  background: var(--common-light-bg, #f9f9f9);\n}\n\n.previewTitle {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--content-text-secondary, #909090);\n  margin-bottom: 12px;\n}\n\n.cardMock {\n  background: var(--white-color, #fff);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  overflow: hidden;\n  margin-bottom: 20px;\n}\n\n.cardBanner {\n  height: 90px;\n  background: linear-gradient(135deg, #d32f2f 0%, #0e9488 100%);\n  background-size: cover;\n  background-position: center;\n}\n\n.cardBody {\n  padding: 12px;\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.cardIcon {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-1, 6px);\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.cardIconPlaceholder {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-1, 6px);\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-weight: 700;\n  background: var(--primary-bg, #d32f2f);\n}\n\n.cardName {\n  font-weight: 700;\n  color: var(--content-text, #181817);\n}\n\n.cardSub {\n  font-size: 12px;\n  color: var(--content-text-secondary, #909090);\n  text-transform: capitalize;\n}\n\n.cardPopular {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fff;\n  background: #0e9488;\n  border-radius: 999px;\n  padding: 2px 7px;\n  margin-left: auto;\n}\n\n/* SEO snippet (Google-result style) */\n.seoSnippet {\n  background: var(--white-color, #fff);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-1, 6px);\n  padding: 12px;\n}\n\n.seoUrl {\n  font-size: 12px;\n  color: #0e9488;\n  word-break: break-all;\n}\n\n.seoTitle {\n  color: #1a0dab;\n  font-size: 16px;\n  margin: 2px 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.seoDesc {\n  font-size: 12px;\n  color: var(--content-text-secondary, #606060);\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `CategoryStudioForm-layout-CjR4e`,
	"tabs": `CategoryStudioForm-tabs-vi1Nz`,
	"tab": `CategoryStudioForm-tab-Kvj_V`,
	"tabActive": `CategoryStudioForm-tabActive-r3zSU`,
	"panel": `CategoryStudioForm-panel-qLWyW`,
	"panelActive": `CategoryStudioForm-panelActive-IwyiU`,
	"grid2": `CategoryStudioForm-grid2-WSqPn`,
	"fieldFull": `CategoryStudioForm-fieldFull-W1IWX`,
	"counter": `CategoryStudioForm-counter-mOrFl`,
	"slugRow": `CategoryStudioForm-slugRow-DKbzb`,
	"genBtn": `CategoryStudioForm-genBtn-xeTRD`,
	"preview": `CategoryStudioForm-preview-mXh6c`,
	"previewTitle": `CategoryStudioForm-previewTitle-NpEJ1`,
	"cardMock": `CategoryStudioForm-cardMock-oot_0`,
	"cardBanner": `CategoryStudioForm-cardBanner-awY7i`,
	"cardBody": `CategoryStudioForm-cardBody-T4Z3u`,
	"cardIcon": `CategoryStudioForm-cardIcon-cDcQE`,
	"cardIconPlaceholder": `CategoryStudioForm-cardIconPlaceholder-ishjZ`,
	"cardName": `CategoryStudioForm-cardName-S2UAl`,
	"cardSub": `CategoryStudioForm-cardSub-vBlfC`,
	"cardPopular": `CategoryStudioForm-cardPopular-qxNSS`,
	"seoSnippet": `CategoryStudioForm-seoSnippet-vcP_M`,
	"seoUrl": `CategoryStudioForm-seoUrl-LeEYQ`,
	"seoTitle": `CategoryStudioForm-seoTitle-O5U8I`,
	"seoDesc": `CategoryStudioForm-seoDesc-LyiVF`
};
module.exports = ___CSS_LOADER_EXPORT___;
